import type { SavedFilterSource } from '@enterprise/api';

import { datastreamQueryKeys } from '@/common/query-keys';

export const savedFiltersQueryKeys = {
  base: [...datastreamQueryKeys.base, 'saved-filters'] as const,
  list: (source: SavedFilterSource) => {
    return [...savedFiltersQueryKeys.base, source] as const;
  },
};
